import {useQuery} from '@tanstack/react-query';
import {GraphStatistics} from '../interface';
import {GraphViewKind} from '../../../../../../components/graph/interface';
import {apiClient} from '../../../../../../utils/api-client';

function getQueryStatsRequest(
    queryId: number,
    viewKind: GraphViewKind,
    maxPathLength: number,
    invisibleNodes: number[]
) {
    return apiClient.post<GraphStatistics>({
        path: `queries-service/api/queries/${queryId}/connection-graph/${viewKind}/statistics`,
        parameters: {
            pathLengthLimit: maxPathLength,
            hiddenViewNodeIds: invisibleNodes
        }
    });
}

export function useGetQueryStats(
    queryId: number,
    viewKind: GraphViewKind,
    maxPathLength: number,
    invisibleNodes: number[]
) {
    return useQuery({
        queryKey: ['query-graph-statistics', queryId, viewKind, maxPathLength, ...invisibleNodes],
        queryFn: () => getQueryStatsRequest(queryId, viewKind, maxPathLength, invisibleNodes)
    });
}
